module.exports = __webpack_public_path__ + "img/b1.5a493e79.png";